import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import content from './content';

const STORAGE_KEY = 'sh-lang';
const LanguageContext = createContext(null);

function initialLang() {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved === 'ar' || saved === 'en') return saved;
  } catch (e) {
    /* storage unavailable */
  }
  const nav = (navigator.language || '').toLowerCase();
  return nav.startsWith('ar') ? 'ar' : 'en';
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(initialLang);

  useEffect(() => {
    const html = document.documentElement;
    html.lang = lang;
    html.dir = lang === 'ar' ? 'rtl' : 'ltr';
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
    } catch (e) {
      /* storage unavailable */
    }
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      isAr: lang === 'ar',
      t: content[lang],
      setLang,
      toggle: () => setLang((l) => (l === 'ar' ? 'en' : 'ar')),
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used inside <LanguageProvider>');
  return ctx;
}

// Sets the browser tab title for each page
export function usePageTitle(title) {
  const { t } = useLang();
  useEffect(() => {
    document.title = title ? `${title} | ${t.meta.siteName}` : t.meta.defaultTitle;
  }, [title, t]);
}
